import ImageWithPlaceholder from 'components/ImageWithPlaceholder/ImageWithPlaceholder';
import styled from 'styled-components';

export const PreviewSection = styled.div`
  width: 100%;
  max-width: 600px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  border: 1px solid #eee;
`;

export const CoverImage = styled.div`
  width: 100%;
  aspect-ratio: 16 / 9;
  margin: 0 auto;
  background-image: url(${({ imageUrl }) => imageUrl || 'none'});
  background-size: cover;
  background-position: center;
  background-color: rgba(0, 0, 0, 0.1);
`;

export const LogoSection = styled.div`
  flex-shrink: 0;
  width: 150px;
  padding-bottom: 16px;
`;

export const LogoContainer = styled.div`
  margin-top: -50px;
  width: 100%;
  aspect-ratio: 1 / 1;
  padding: 4px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
`;

export const Logo = styled(ImageWithPlaceholder)`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
  border: 1px solid #eee;
  cursor: pointer;
`;
